<template>
  <history-item-template
    :createTime="action.createTime"
    :creatorName="action.creatorName"
    :comment="action.data.comment"
    :vbAttachments="action.attachments"
    @downloadFile="({vbAttachment}) => $emit('downloadFile', {vbAttachment})"
  >
    <template #historyHeader>
      <p
        :class="['action-type flex-row flex__left inline-flex', 'color__green']"
      >
        <i :class="['font-size__small', 'fal fa-edit']"></i>
        <span class="font-size__small no_wrap"> &nbsp;{{ "Cho ý kiến" }} </span>
      </p>
    </template>
  </history-item-template>
</template>

<script>
import convertToLabelFilter from "../../filters/convertToLabelFilter";
import HistoryItemTemplate from "../common/layout/history-item-template";

export default {
  name: "doc-in-cho-y-kien-history-item",
  components: { HistoryItemTemplate },
  props: ["action"],
  filters: {
    convertToLabelFilter
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/doc-in-cho-y-kien-history-item.vue